import * as React from 'react';
import { Component } from '../../lib/component';
import { PaginatedTable, PaginatedTableColumn } from '../table/paginated';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { ArtistNames } from '../artist/names';
import {formatCurrency} from '../../lib/currency';
import {OrderSchema} from '../../types/schema';
import {PaginationMeta} from '../../types';

export interface AccountOrdersProps {
  orders: Array<OrderSchema>;
  pagination: PaginationMeta;
  loadingMore: boolean;
  pathRoot: string;
  isMobile: boolean;
}

type PaginatedOrdersTable = new () => PaginatedTable<OrderSchema>;
const PaginatedOrdersTable = PaginatedTable as PaginatedOrdersTable;

export class AccountOrders extends Component<AccountOrdersProps> {
  render() {
    const { orders = [], pagination, loadingMore, pathRoot, isMobile } = this.props;

    return (
      <PaginatedOrdersTable
        rows={orders}
        columns={AccountOrders.Columns}
        pagination={pagination}
        loadingMore={loadingMore}
        pathRoot={pathRoot}
        isMobile={isMobile}
      />
    )
  }

  static Columns: Array<PaginatedTableColumn<OrderSchema>> = [
    {
      i18nKey: 'account.orders.table.id.title',
      render: (order: OrderSchema) => (
        <div>{order.sequence || 17}</div>
      )
    },
    {
      i18nKey: 'account.orders.table.licences.title',
      render: (order: OrderSchema) => order.licences.map(licence => (
        <div key={licence.identity}>
          <div>{licence.track.title}</div>
          <ArtistNames artists={licence.track.artists} />
        </div>
      ))
    },
    {
      i18nKey: 'account.orders.table.amount.title',
      render: (order: OrderSchema) => (
        <FormattedMessage id="account.orders.table.amount.value" values={{
          amount: formatCurrency(order.amount.total, order.locale.currency)
        }} />
      )
    },
    {
      i18nKey: 'account.orders.table.actions.title',
      render: (order: OrderSchema) => (
        <div>
          <Link to={`/account/order/${order.identity}`}>
            <FormattedMessage id="account.orders.table.view_order.title" />
          </Link>
        </div>
      )
    },
  ];
}